import { computedFrom, autoinject, observable, bindable } from 'aurelia-framework';
import { State } from '../../../services/global-state';
import { PayrazrService } from '../../../services/payrazr';
import { ValidationHelpers } from '../../../services/validation-helpers';
import { I18N } from 'aurelia-i18n';

@autoinject
export class WalletForm {
	paymentFormContext: any;
	selectedPaymentMethod: any;
	savedPaymentMethods: any;
	customFields: any;
	cardCustomFields: any;
	checkCustomFields: any;
	showCvv: any;
	cvvRequired: any;
	@bindable cvv: any;
	walletData: WalletForm;
	portfolioName: any;
	checkNumberSettings: any;
	checkNumber: any;

	constructor(private globalState: State, private payrazrService: PayrazrService, private i18n: I18N) {
		this.selectedPaymentMethod = {};
		this.savedPaymentMethods = [];
		this.customFields = [];
		this.cardCustomFields = [];
		this.checkCustomFields = [];
		this.showCvv = true;
		this.cvvRequired = false;
		this.cvv = '';
		this.checkNumber = '';
	}

	activate(walletData: WalletForm) {
		this.walletData = walletData;

		this.checkNumberSettings = this.globalState.business.portalSettings.fields.checkNumber;
		if (!!this.checkNumberSettings && !this.checkNumberSettings.label) {
			this.checkNumberSettings.label = this.i18n.i18next.t('checkNumber', 'Check Number');
		}
	}

	differentPaymentMethodSelected() {
		this.paymentFormContext?.getFeeInformation();
	}

	validate(errors) {
		if (!this.getSelectedPaymentMethod.cardInfoKey && !this.getSelectedPaymentMethod.checkInfoKey) {
			errors.push(this.i18n.i18next.t('paymentMethodRequired', 'Payment method is required'));
		}

		if (this.getSelectedPaymentMethod.cardInfoKey) {
			if (this.showCvv && this.cvvRequired) {
				if (this.cvv.length === 0) {
					errors.push(this.i18n.i18next.t('cardSecurityCodeRequired', 'Card security code is required'));
				} else if (this.cvv.length > 4) {
					errors.push(this.i18n.i18next.t('invalidCardSecurityCode', 'Invalid card security code'));
				} else if (!ValidationHelpers.isOnlyDigits(this.cvv)) {
					errors.push(this.i18n.i18next.t('invalidCardSecurityCode', 'Invalid card security code'));
				}
			}
		}

		if (!this.isCardPaymentMethodSelected) {
			if (this.checkNumber.length === 0 && this.globalState.business.portalSettings.fields.checkNumber.required) {
				errors.push(this.i18n.i18next.t('checkNumberRequired', 'Check Number is required'));
			} else if (!ValidationHelpers.isOnlyDigits(this.checkNumber)) {
				errors.push(this.i18n.i18next.t('checkNumberCanContainOnlyDigits', 'Check Number can contain only digits'));
			}
		}

		for (let ii = 0; ii < this.customFields.length; ++ii) {
			let field = this.customFields[ii];
			if (field.visible && field.required && (!field.value || field.value.length === 0)) {
				let label = field.label || `Custom Field ${ii + 1}`;
				errors.push(this.i18n.i18next.t('nameIsRequired', { defaultValue: `${label} is required`, name: label }));
			}
		}

		if (this.getSelectedPaymentMethod.cardInfoKey && this.getSelectedPaymentMethod.cardInfoKey > 0) {
			return this.payrazrService.checkCardType(0, this.portfolioName, this.getSelectedPaymentMethod.cardInfoKey)
				.then(response => {
					if (!response.isValid) {
						errors.push(response.message);
					}
				});

		} else {
			return new Promise((accept: any, reject) => {
				accept();
			});
		}
	}

	mapAccountTypeToApi() {
		switch (this.getSelectedPaymentMethod.achAccountType) {
			case 'PersonalChecking': return 1;
			case 'PersonalSavings': return 2;
			case 'BusinessChecking': return 3;
		}
	}

	@computedFrom('selectedPaymentMethod')
	get isCardPaymentMethodSelected() {
		if (this.walletData) {
			this.selectedPaymentMethod = this.walletData.selectedPaymentMethod;
			this.cardCustomFields = this.walletData.cardCustomFields;
			this.checkCustomFields = this.walletData.checkCustomFields;
		}

		if (this.selectedPaymentMethod && this.selectedPaymentMethod.cardInfoKey) {
			this.customFields = this.cardCustomFields;
			return true;
		}
		else if (this.selectedPaymentMethod) {
			this.customFields = this.checkCustomFields;
			return false;
		}
		else {
			this.customFields = [];
			return false;
		}
	}

	@computedFrom('walletData.savedPaymentMethods')
	get primaryPaymentMethod() {
		return this.walletData.savedPaymentMethods.find(pm => pm.isPrimaryPaymentMethod);
	}

	@computedFrom('walletData.savedPaymentMethods')
	get savedPaymentMethodOptions() {
		return this.walletData.savedPaymentMethods;
	}

	@computedFrom('walletData.savedPaymentMethods')
	get savedPaymentMethodDescs() {
		return this.walletData.savedPaymentMethods.map(pm => `${pm.cardType || pm.achAccountType} ending ${pm.last4ofCard || pm.last4ofAccount}`);
	}

	@computedFrom('selectedPaymentMethod')
	get getSelectedPaymentMethod() {
		return this.selectedPaymentMethod;
	}

	@computedFrom('getSelectedPaymentMethod')
	get nameLabel() {
		if (this.getSelectedPaymentMethod && this.getSelectedPaymentMethod.nameLabel) {
			return this.getSelectedPaymentMethod.nameLabel;
		} else {
			return 'Name';
		}
	}

}
